var currency = require('./currency')
var datetime = require('./datetime')
var numerics = require('./numerics')
var phone = require('./phone')
var getDateUtils = require('./date-utils').getByLocale
var getNumberUtils = require('./number-utils').getByLocale
var getPhoneUtils = require('./phone-utils').getByLocale
var stringSort = require('./string-sort')
var maskFromString = require('./mask-from-string')
var customPattern = require('./custom-pattern')
var currencyRounder = require('./currency-rounder')

module.exports = {
  currency: currency,
  datetime: datetime,
  getDateUtils: getDateUtils,
  getNumberUtils: getNumberUtils,
  getPhoneUtils: getPhoneUtils,
  number: numerics.number,
  phone: phone.phone,
  phoneUtils: phone.utils,
  stringSort: stringSort,
  maskFromString: maskFromString,
  customPattern: customPattern,
  currencyRounder: currencyRounder,
}
